<div [formGroup]="formGroup" (change)="onBlur()">
    <div class="d-flex" [class.flex-column]="layout() === 'vertical'">
        <app-input-date-group
            style="max-width: 200px"
            class="d-inline-block"
            [class.me-3]="layout() === 'horizontal'"
            [class.mb-3]="layout() === 'vertical'"
            [label]="
                'input-date-range-picker_start-date' | translate: 'common' : 'brunata-angular-ui'
            "
            [required]="required"
            [outsideDays]="outsideDays()"
            [minDate]="minDate()"
            [maxDate]="maxDate()"
            (blur)="onBlur()"
            formControlName="startDate" />
        <app-input-date-group
            style="max-width: 200px"
            class="d-inline-block"
            [label]="
                'input-date-range-picker_end-date' | translate: 'common' : 'brunata-angular-ui'
            "
            [required]="required"
            [outsideDays]="outsideDays()"
            [minDate]="minDate()"
            [maxDate]="maxDate()"
            (blur)="onBlur()"
            formControlName="endDate" />
    </div>
    <app-control-messages [control]="formGroup"></app-control-messages>
</div>
